export default "__VITE_ASSET__DeF5Lsav__$_?react__"